import React from 'react'
import { ButtonDiv } from './ButtonStyles'
import { BUTTON_PROPS } from './interface'

export default function Button({
  children,
  width,
  height,
  size,
  background,
  borderColor,
  textColor,
  shadow,
  radius,
  margin,
  opacity,
  isDisabled,
  stakeColor,
  font,
  func,
  childMargin,
  startAuto,
  autoPlayIsOn,
}: BUTTON_PROPS) {
  return (
    <ButtonDiv
      width={width}
      height={height}
      size={size}
      background={background}
      borderColor={borderColor}
      textColor={textColor}
      shadow={shadow}
      radius={radius}
      margin={margin}
      opacity={opacity}
      stakeColor={stakeColor}
      font={font}
      isDisabled={isDisabled}
      childMargin={childMargin}
      onClick={() => func()}
      startAuto={startAuto || autoPlayIsOn}
    >
      <div className='btn'>{children}</div>
    </ButtonDiv>
  )
}
